import { ConfigService } from './../../services/webFeeder/config.service';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewContainerRef, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject , of } from 'rxjs';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { NotificationsService } from 'angular2-notifications';
import { Constants } from '@utils/constants';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { AuthServer } from '@services/auth-server.service';
import { SystemServiceErrorCodKeyEnum, SystemServiceErrorEnum } from '@model/enum/system-services-error-msg';

@Component({
  selector: 'app-assessor-search-client',
  templateUrl: './assessor-search-client.component.html'
})
export class AssessorSearchClientComponent implements OnInit, OnDestroy, AfterViewInit, ICellEditorAngularComp {

  @Input() autoSizeActive = false;
  @Input() nameAutoComplete: string;
  @Input() autoFocus: boolean;
  @Input() reset: Subject<boolean>;
  @Output() hiddenInvalidOutput = new EventEmitter<Boolean>();
  @Output() rawInformation = new EventEmitter<String>();
  @ViewChild('autoInput', { read: ViewContainerRef }) public input;
  private params: any;
  private selectedFlag = false;
  inputName = false;
  username = '';
  image = '';
  listAssessorClient: any;
  listAssessorClientAux: any;
  loadingInit: any;
  loading = true;
  hiddenInvalid = true;
  isWorksheet = false;
  isPaste: boolean;
  organization: any;
  messageLogout = { title: '', subTitle: '' };

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    public _dialogRef: MatDialogRef<AssessorSearchClientComponent>,
    public _configService: ConfigService,
    private _notificationService: NotificationsService,
    private _autoLogoutService: AutoLogoutService,
    private _authServer: AuthServer,
  ) {
    this.organization = this._configService.getConfigWhitelabel();
    if (this.organization) {
      this.messageLogout.title = this.organization.login.messageLogout.title ? this.organization.login.messageLogout.title : Constants.ERROR_SYSTEM_TEXT;
      this.messageLogout.subTitle = this.organization.login.messageLogout.subTitle ? this.organization.login.messageLogout.subTitle : null;
    }
    this.nameAutoComplete = '';
    this.image = './assets/images/assets/avatar.svg';
    this.getListAssessorClient();
  }

  getListAssessorClient() {
    this._authServer.iNegotiation.brokerServiceAccountList(null)
      .subscribe(res => {
        this.listAssessorClientAux = res;
        this.listAssessorClient = res;
        this.loading = false;
      }, error => {
        if (error.status === 401 || error.status === 110) {
          this._configService.writeLog('SIDEBAR > errorCode: ' + error.status + ' - URL: ' + error.url);
          this._configService._authHbLoginType.next(3);
          this._configService.redirectExpireSession(this.messageLogout.title, this.messageLogout.subTitle,
            SystemServiceErrorEnum.brokerServiceAccountList, SystemServiceErrorCodKeyEnum.unautorized);
        } else {
          this._notificationService.error(Constants.ERROR_REQUEST);
        }
        this.closeDialog();
      });
  }

  toggleInput() {
    this.hiddenInvalid = !this.hiddenInvalid;
  }

  closeDialog() {
    this._dialogRef.close();
  }

  ngOnInit() {
    this.nameAutoComplete = '';
    if (this.reset) {
      setTimeout(() => {
        this.reset.subscribe(v => {
          this.hiddenInvalid = true;
        });
      }, 0);
    }
  }

  ngOnDestroy() {
    if (this.reset) {
      this.reset.unsubscribe();
    }
    if (this.loadingInit) {
      clearTimeout(this.loadingInit);
    }
  }

  ngAfterViewInit() {
    if (this.autoFocus) {
      setTimeout(() => {
        this.focusInput();
      }, 1000);
    }
  }

  focusInput() {
    this.input.element.nativeElement.focus();
  }

  getValue(): any {
    return this.nameAutoComplete;
  }

  onInputEnter(event) {
    setTimeout(() => {
      if (!this.selectedFlag) {
        if (event.target.value === '' && event.key.includes('Enter')) {
          this._notificationService.warn('', Constants.WORKSPACE_MSG019);
          return;
        }
      } else {
        this.selectedFlag = false;
      }
    }, 200);
  }

  onAutoCompletAsset(textInput: any) {
    this.hiddenInvalid = true;
    this.hiddenInvalidOutput.emit(this.hiddenInvalid);
    if (textInput.key !== 'ArrowDown' && textInput.key !== 'ArrowUp' && textInput.key !== 'Enter') {
      if (textInput.target === undefined) {
        this.nameAutoComplete = textInput.toLowerCase();
      } else {
        this.nameAutoComplete = textInput.target.value.toLowerCase();
      }
      if (!this.isPaste) {
        this.rawInformation.emit(this.nameAutoComplete);
      }
      this.listAssessorClient = this.listAssessorClientAux;
      this.listAssessorClient = this.listAssessorClient.filter(element =>
        element.full_name.toLowerCase().indexOf(this.nameAutoComplete) === 0 || element.account.toString().indexOf(this.nameAutoComplete) === 0);
      this.isPaste = true;
      return this.listAssessorClient;
    }
  }

  callBackWorksheet() {
    if (this.isWorksheet) {
      this.params.api.stopEditing();
    }
  }

  agInit(params: any): void {
    this.params = params;
    this.nameAutoComplete = this.params.value;
    this.isWorksheet = true;
    setTimeout(() => {
      this.input.element.nativeElement.focus();
    });
  }

  selecClient(client) {
    if (client) {
      this._configService.setAssessorClientSelected(client);
      this._configService.setBrokerAccountSelected(client.account, true);
      this._configService.setBrokerAccountSelectedTransition(client.account);
      this._configService._clientAssessorChangeSelect.next(true);
      this._dialogRef.close();
    }
  }

}
